import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	map: {
		display: "block",
		margin: "0 -16px",
		"& img": {
			display: "block",
			height: "auto",
			width: "100%",
			[theme.breakpoints.up("md")]: {
				maxWidth: 535
			}
		},
		[theme.breakpoints.up("md")]: {
			margin: "0 0 0 auto"
		}
	}
}));

export default styles;
